// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "8fd0613b0b44ade57ec3f80fcbd6842d" + ".js";
};